import { render, staticRenderFns } from "./voucher_type.vue?vue&type=template&id=119fbba3&scoped=true&"
import script from "./voucher_type.vue?vue&type=script&lang=js&"
export * from "./voucher_type.vue?vue&type=script&lang=js&"
import style0 from "./voucher_type.vue?vue&type=style&index=0&id=119fbba3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119fbba3",
  null
  
)

export default component.exports